import { render, staticRenderFns } from "./SupplementaryApprovalTeacher.vue?vue&type=template&id=6dcc53f4&scoped=true&"
import script from "./SupplementaryApprovalTeacher.vue?vue&type=script&lang=js&"
export * from "./SupplementaryApprovalTeacher.vue?vue&type=script&lang=js&"
import style0 from "./SupplementaryApprovalTeacher.vue?vue&type=style&index=0&id=6dcc53f4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcc53f4",
  null
  
)

export default component.exports